exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2tRKmDJv0z8SHjtR7Gu62C .od-ShareHeader-linkSettings{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._2tRKmDJv0z8SHjtR7Gu62C .od-ShareHeader-linkSettings{margin:0;padding:12px}html[dir] ._2tRKmDJv0z8SHjtR7Gu62C .od-ModifyPermissions-section{padding:0}._2tRKmDJv0z8SHjtR7Gu62C .od-Share{width:350px}", ""]);

// exports
exports.locals = {
	"sharingDialog": "_2tRKmDJv0z8SHjtR7Gu62C"
};